export const ServerMessages = {
  ROOM_CREATED: "ROOM_CREATED",
  ROOM_DELETED: "ROOM_DELETED",
  ROOM_JOINED: "ROOM_JOINED",
  PLAYER_JOINED: "PLAYER_JOINED",
  CHAT_MESSAGE: "CHAT_MESSAGE",
  START_GAME: "START_GAME",
  ALLOCATE_CARDS: "ALLOCATE_CARDS",
  DEAL_CARDS: "DEAL_CARDS",
  NOTIFY_PLAYERS_TO_START_THEIR_TIMER: "NOTIFY_PLAYERS_TO_START_THEIR_TIMER",
  TURN_AND_TIMER_SYNC: "TURN_AND_TIMER_SYNC",
  PLAYER_FOLDED: "PLAYER_FOLDED",
  PLAYER_CALLED: "PLAYER_CALLED",
  PLAYER_RAISED: "PLAYER_RAISED",
  CELEBRATE_AND_PAY_WINNER: "CELEBRATE_AND_PAY_WINNER",
  PAY_PLAYER_ROUND_BET_DIFFERENCE: "PAY_PLAYER_ROUND_BET_DIFFERENCE",
  DEAL_TABLE_CARDS: "DEAL_TABLE_CARDS",
  REVEAL_TABLE_CARDS: "REVEAL_TABLE_CARDS",
  REFRESH_TABLE_POT_AND_RESET_PLAYERS_ACTIONS: "REFRESH_TABLE_POT_AND_RESET_PLAYERS_ACTIONS",
  SHOW_ALL_PLAYERS_IN_GAME_CARDS: "SHOW_ALL_PLAYERS_IN_GAME_CARDS",
  CARD_REVEALED: "CARD_REVEALED",
  GAME_NOT_ENOUGH_PLAYERS: "GAME_NOT_ENOUGH_PLAYERS",
  PLAYER_EXITED: "PLAYER_EXITED",
  GAME_ENDED: "GAME_ENDED",
  PLAYER_LEFT_ROOM: "PLAYER_LEFT_ROOM",
  HOST_PLAYER_CHANGED: "HOST_PLAYER_CHANGED",
  CHAT_MESSAGE_GAME: "CHAT_MESSAGE_GAME",
  START_GAME_JOINED_PLAYER: "START_GAME_JOINED_PLAYER",
  ADD_PLAYER_TO_GAME: "ADD_PLAYER_TO_GAME",
  PLAYER_SIT_OUT: "PLAYER_SIT_OUT",
  PLAYER_STANDING: "PLAYER_STANDING",
  PLAYER_SAT: "PLAYER_SAT",
  STANDING_COUNTDOWN: "STANDING_COUNTDOWN",
  /** Disconnected player grace countdown: playerId -> secondsRemaining. Show "Disconnected" + countdown on seat. */
  DISCONNECT_GRACE_COUNTDOWN: "DISCONNECT_GRACE_COUNTDOWN",
  GAME_HELD_WAITING_FOR_SEAT: "GAME_HELD_WAITING_FOR_SEAT",
  GAME_START_UI: "GAME_START_UI",
  ERROR_MESSAGE: "ERROR_MESSAGE",
  NORMAL_MESSAGE: "NORMAL_MESSAGE",
  WARNING_MESSAGE: "WARNING_MESSAGE",
  ONLINE_FRIENDS: "ONLINE_FRIENDS",
  FRIEND_CHAT_MESSAGE: "FRIEND_CHAT_MESSAGE",
  FRIEND_CHAT_UNREAD_COUNTS: "FRIEND_CHAT_UNREAD_COUNTS",
  OBSERVERS_LIST: "OBSERVERS_LIST",
  OBSERVER_JOINED: "OBSERVER_JOINED",
  OBSERVER_LEFT: "OBSERVER_LEFT",
  PLAYER_BUSTED: "PLAYER_BUSTED",
  /** Table will close after current hand (e.g. open 12+ hours). Finish hand, celebrate, then table/lobby close. */
  TABLE_CLOSING_AFTER_HAND: "TABLE_CLOSING_AFTER_HAND",
} as const;

